<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="460px"
    :before-close="close">
    <div>
      <p style="font-size: 15px; line-height: 22px; color: #141414">{{tips}}</p>
    </div>
    <div slot="footer" align="center">
      <template v-if="actionLabel === '我知道了'">
        <el-button @click="close">我知道了</el-button>
      </template>
      <template v-else>
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleAct">{{actionLabel}}</el-button>
      </template>
    </div>
  </el-dialog>
  
</template>

<script>
import {mapState} from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['Authorization']),
    tips() {
      if (this.Authorization && this.Authorization.authenticationInfoDTO) {
        if (this.Authorization.authenticationInfoDTO.type != '1') {
          return  '您当前账号还不是销售代理身份，去升级销售代理身份即可参与发布整柜询盘内容。'
        } else {
          if (this.Authorization.authenticationInfoDTO.state == '1') { // 待认证
            return '您申请销售代理身份正在审核中，请耐心等待，如有任何疑问，请在右侧栏点击联系平台。'
          } else if (this.Authorization.authenticationInfoDTO.state != '3') {
            return '您当前账号还未实名认证，需认证通过才能发布整柜询盘内容。'
          }
        }
      }
      return ''
    },
    actionLabel() {
      if (this.Authorization && this.Authorization.authenticationInfoDTO) {
        if (this.Authorization.authenticationInfoDTO.type != '1') {
          return  '升级为销售代理'
        } else {
          if (this.Authorization.authenticationInfoDTO.state == '1') { // 待认证
            return '我知道了'
          } else if (this.Authorization.authenticationInfoDTO.state != '3') {
            return '去认证'
          }
        }
      }
      return ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleAct() {
      if (this.Authorization.authenticationInfoDTO.type != '1') {
        this.$router.push('/placeOrder/supplierJoin')
      } else {
        this.$router.push({
          path:"/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
        });
      }
      this.$emit('close')
    }
  }
}
</script>
<style lang="" scoped>
  .el-dialog__wrapper .el-dialog {
    border: 20px
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/blockPublishInquiry.vue